(() => {
  if (window.__bhaktiProfessionalCartV4) return;
  window.__bhaktiProfessionalCartV4 = true;

  document.getElementById('bhakti-professional-cart-v2')?.remove();
  document.getElementById('bhakti-professional-cart-v3')?.remove();
  document.getElementById('bhakti-professional-cart-v4')?.remove();

  const style = document.createElement('style');
  style.id = 'bhakti-professional-cart-v4';
  style.textContent = `
    .cart-drawer .bhakti-cart-auto-gift .cart-item__totals,
    .cart-drawer .bhakti-cart-auto-gift .cart-item__quantity {
      display: none !important;
    }

    @media screen and (max-width: 749px) {
      .cart-drawer .cart-items,
      .cart-drawer .cart-items tbody {
        display: block !important;
        width: 100% !important;
      }

      .cart-drawer .cart-items thead {
        display: none !important;
      }

      .cart-drawer .drawer__cart-items-wrapper {
        width: 100% !important;
        padding: 0 !important;
        margin: 0 !important;
        overflow: visible !important;
      }

      /* Paid item: true two-column mobile card. Image left, everything else right. */
      .cart-drawer .cart-item:not(.bhakti-cart-auto-gift) {
        display: grid !important;
        width: 100% !important;
        min-width: 0 !important;
        max-width: 100% !important;
        box-sizing: border-box !important;
        grid-template-columns: 9rem minmax(0, 1fr) !important;
        grid-template-rows: auto auto auto !important;
        column-gap: 1.15rem !important;
        row-gap: .5rem !important;
        align-items: start !important;
        margin: 0 0 1rem !important;
        padding: 1.1rem !important;
        border: 1px solid rgba(74, 53, 44, .14) !important;
        border-radius: 1.45rem !important;
        background: #fffdf9 !important;
        box-shadow: 0 .35rem 1.2rem rgba(54, 39, 31, .045) !important;
        overflow: hidden !important;
      }

      .cart-drawer .cart-item:not(.bhakti-cart-auto-gift) > td {
        box-sizing: border-box !important;
        min-width: 0 !important;
        margin: 0 !important;
        padding: 0 !important;
      }

      .cart-drawer .cart-item:not(.bhakti-cart-auto-gift) > .cart-item__media {
        grid-column: 1 !important;
        grid-row: 1 / 4 !important;
        width: 9rem !important;
        min-width: 9rem !important;
        max-width: 9rem !important;
        align-self: start !important;
        position: relative !important;
      }

      .cart-drawer .cart-item:not(.bhakti-cart-auto-gift) .cart-item__image-container,
      .cart-drawer .cart-item:not(.bhakti-cart-auto-gift) .cart-item__image {
        display: block !important;
        width: 9rem !important;
        min-width: 9rem !important;
        max-width: 9rem !important;
      }

      .cart-drawer .cart-item:not(.bhakti-cart-auto-gift) .cart-item__image {
        height: 9rem !important;
        object-fit: cover !important;
        border-radius: 1rem !important;
      }

      .cart-drawer .cart-item:not(.bhakti-cart-auto-gift) > .cart-item__details {
        grid-column: 2 !important;
        grid-row: 1 !important;
        width: 100% !important;
        min-width: 0 !important;
        max-width: 100% !important;
        align-self: start !important;
      }

      .cart-drawer .cart-item__title {
        display: flex !important;
        flex-direction: column !important;
        align-items: flex-start !important;
        gap: .35rem !important;
        width: 100% !important;
        min-width: 0 !important;
        margin: 0 !important;
      }

      .cart-drawer .cart-item__name {
        display: -webkit-box !important;
        width: 100% !important;
        min-width: 0 !important;
        max-width: 100% !important;
        -webkit-box-orient: vertical !important;
        -webkit-line-clamp: 2 !important;
        overflow: hidden !important;
        text-overflow: ellipsis !important;
        overflow-wrap: anywhere !important;
        color: #211714 !important;
        font-size: 1.38rem !important;
        font-weight: 850 !important;
        line-height: 1.22 !important;
        text-decoration: none !important;
      }

      .cart-drawer .cart-item__details > .cart-item__discounted-prices,
      .cart-drawer .cart-item__details > .product-option,
      .cart-drawer .cart-item__details > p.product-option,
      .cart-drawer .cart-item__details > .discounts {
        display: none !important;
      }

      .cart-drawer .cart-item__details dl {
        margin: .4rem 0 0 !important;
        padding: 0 !important;
      }

      .cart-drawer .cart-item__details dl .product-option {
        display: none !important;
      }

      .cart-drawer .cart-item__details dl .product-option:first-child {
        display: block !important;
        margin: 0 !important;
        color: #4d3b34 !important;
        font-size: 1.12rem !important;
        font-weight: 800 !important;
        line-height: 1.2 !important;
      }

      .cart-drawer .cart-item__details dl .product-option:first-child dt {
        display: none !important;
      }

      .cart-drawer .cart-item__details dl .product-option:first-child dd {
        display: block !important;
        margin: 0 !important;
      }

      .cart-drawer .cart-item:not(.bhakti-cart-auto-gift) > .cart-item__totals {
        grid-column: 2 !important;
        grid-row: 2 !important;
        display: flex !important;
        width: 100% !important;
        min-width: 0 !important;
        max-width: 100% !important;
        justify-self: stretch !important;
        align-self: start !important;
        align-items: center !important;
        justify-content: flex-start !important;
        margin: .05rem 0 0 !important;
        padding: 0 !important;
        text-align: left !important;
        pointer-events: none !important;
      }

      .cart-drawer .cart-item__price-wrapper {
        display: flex !important;
        align-items: center !important;
        justify-content: flex-start !important;
        width: 100% !important;
        min-width: 0 !important;
        margin: 0 !important;
      }

      .cart-drawer .cart-item__totals .cart-item__old-price {
        display: none !important;
      }

      .cart-drawer .cart-item__totals .price,
      .cart-drawer .cart-item__totals .cart-item__final-price {
        display: block !important;
        color: #211714 !important;
        font-size: 1.38rem !important;
        font-weight: 900 !important;
        line-height: 1.15 !important;
        white-space: nowrap !important;
        text-align: left !important;
        margin: 0 !important;
      }

      .cart-drawer .cart-item:not(.bhakti-cart-auto-gift) > .cart-item__quantity {
        grid-column: 2 !important;
        grid-row: 3 !important;
        display: block !important;
        width: 100% !important;
        min-width: 0 !important;
        max-width: 100% !important;
        justify-self: stretch !important;
        align-self: start !important;
        margin: .3rem 0 0 !important;
        padding: 0 !important;
      }

      .cart-drawer .cart-item__quantity quantity-popover {
        display: block !important;
        width: 100% !important;
        min-width: 0 !important;
        max-width: 100% !important;
        margin: 0 !important;
        padding: 0 !important;
      }

      .cart-drawer .cart-item__quantity-wrapper {
        display: flex !important;
        width: 100% !important;
        min-width: 0 !important;
        max-width: 100% !important;
        flex-wrap: nowrap !important;
        align-items: center !important;
        justify-content: flex-start !important;
        gap: .65rem !important;
        margin: 0 !important;
        padding: 0 !important;
      }

      .cart-drawer .quantity-popover-container {
        display: block !important;
        flex: 0 0 11.4rem !important;
        width: 11.4rem !important;
        min-width: 11.4rem !important;
        max-width: 11.4rem !important;
        margin: 0 !important;
        padding: 0 !important;
      }

      .cart-drawer .quantity {
        display: grid !important;
        grid-template-columns: repeat(3, 3.8rem) !important;
        flex: 0 0 11.4rem !important;
        width: 11.4rem !important;
        min-width: 11.4rem !important;
        max-width: 11.4rem !important;
        height: 3.8rem !important;
        min-height: 3.8rem !important;
        max-height: 3.8rem !important;
        box-sizing: border-box !important;
        margin: 0 !important;
        padding: 0 !important;
        overflow: hidden !important;
        border: 1px solid rgba(33, 23, 20, .25) !important;
        border-radius: .9rem !important;
        background: #fffdf9 !important;
        box-shadow: none !important;
      }

      .cart-drawer .quantity::before,
      .cart-drawer .quantity::after {
        content: none !important;
        display: none !important;
        box-shadow: none !important;
        border: 0 !important;
      }

      .cart-drawer .quantity__button,
      .cart-drawer .quantity__input {
        display: flex !important;
        align-items: center !important;
        justify-content: center !important;
        box-sizing: border-box !important;
        width: 3.8rem !important;
        min-width: 0 !important;
        max-width: 3.8rem !important;
        height: 3.8rem !important;
        min-height: 3.8rem !important;
        max-height: 3.8rem !important;
        flex: none !important;
        margin: 0 !important;
        padding: 0 !important;
        border: 0 !important;
        background: transparent !important;
        color: #211714 !important;
        font-size: 1.45rem !important;
        line-height: 1 !important;
        box-shadow: none !important;
      }

      .cart-drawer .quantity__button:first-child,
      .cart-drawer .quantity__button:last-child {
        margin: 0 !important;
      }

      .cart-drawer .quantity__input {
        text-align: center !important;
        font-weight: 850 !important;
        opacity: 1 !important;
      }

      .cart-drawer .quantity__button .svg-wrapper {
        width: 1rem !important;
        height: 1rem !important;
      }

      .cart-drawer cart-remove-button {
        display: flex !important;
        flex: 0 0 3.8rem !important;
        width: 3.8rem !important;
        min-width: 3.8rem !important;
        max-width: 3.8rem !important;
        height: 3.8rem !important;
        min-height: 3.8rem !important;
        max-height: 3.8rem !important;
        margin: 0 !important;
        padding: 0 !important;
      }

      .cart-drawer .cart-remove-button {
        display: flex !important;
        align-items: center !important;
        justify-content: center !important;
        flex: 0 0 3.8rem !important;
        width: 3.8rem !important;
        min-width: 3.8rem !important;
        max-width: 3.8rem !important;
        height: 3.8rem !important;
        min-height: 3.8rem !important;
        max-height: 3.8rem !important;
        margin: 0 !important;
        padding: 0 !important;
        border: 0 !important;
        border-radius: .8rem !important;
        background: transparent !important;
        color: #8a4035 !important;
        box-shadow: none !important;
      }

      .cart-drawer .cart-remove-button::before,
      .cart-drawer .cart-remove-button::after {
        content: none !important;
        display: none !important;
      }

      .cart-drawer .cart-remove-button .svg-wrapper,
      .cart-drawer .cart-remove-button .icon-remove {
        width: 1.5rem !important;
        height: 1.5rem !important;
      }

      /* Free gift stays as one clean horizontal row. */
      .cart-drawer .bhakti-cart-auto-gift {
        display: grid !important;
        width: 100% !important;
        min-width: 0 !important;
        max-width: 100% !important;
        min-height: 0 !important;
        grid-template-columns: 6.4rem minmax(0, 1fr) !important;
        grid-template-rows: auto !important;
        align-items: center !important;
        column-gap: .9rem !important;
        margin: 0 0 1rem !important;
        padding: .9rem 1rem !important;
        overflow: hidden !important;
        background: #f3f8f3 !important;
        border: 1px solid rgba(45, 103, 75, .18) !important;
        border-radius: 1.35rem !important;
        box-shadow: none !important;
      }

      .cart-drawer .bhakti-cart-auto-gift > td {
        padding: 0 !important;
        margin: 0 !important;
        min-width: 0 !important;
      }

      .cart-drawer .bhakti-cart-auto-gift > .cart-item__media {
        grid-column: 1 !important;
        grid-row: 1 !important;
        width: 6.4rem !important;
        min-width: 6.4rem !important;
        max-width: 6.4rem !important;
        align-self: center !important;
      }

      .cart-drawer .bhakti-cart-auto-gift .cart-item__image-container,
      .cart-drawer .bhakti-cart-auto-gift .cart-item__image {
        display: block !important;
        width: 6.4rem !important;
        min-width: 6.4rem !important;
        max-width: 6.4rem !important;
      }

      .cart-drawer .bhakti-cart-auto-gift .cart-item__image {
        height: 6.4rem !important;
        object-fit: cover !important;
        border-radius: .85rem !important;
      }

      .cart-drawer .bhakti-cart-auto-gift > .cart-item__details {
        grid-column: 2 !important;
        grid-row: 1 !important;
        align-self: center !important;
        width: 100% !important;
        min-width: 0 !important;
        max-width: 100% !important;
      }

      .cart-drawer .bhakti-cart-auto-gift .cart-item__details dl,
      .cart-drawer .bhakti-cart-auto-gift .cart-item__disclosure,
      .cart-drawer .bhakti-cart-auto-gift .cart-item__totals,
      .cart-drawer .bhakti-cart-auto-gift .cart-item__quantity,
      .cart-drawer .bhakti-cart-auto-gift cart-remove-button {
        display: none !important;
      }

      .cart-drawer .bhakti-cart-auto-gift .cart-item__title {
        gap: .5rem !important;
      }

      .cart-drawer .bhakti-cart-auto-gift .cart-item__name {
        -webkit-line-clamp: 1 !important;
        font-size: 1.28rem !important;
      }

      .cart-drawer .bhakti-cart-gift-badge {
        display: inline-flex !important;
        align-items: center !important;
        justify-content: center !important;
        width: auto !important;
        min-width: 0 !important;
        min-height: 0 !important;
        margin: 0 !important;
        padding: .48rem .72rem !important;
        border-radius: 999px !important;
        font-size: .95rem !important;
        font-weight: 850 !important;
        line-height: 1 !important;
        letter-spacing: .04rem !important;
        white-space: nowrap !important;
      }

      .cart-drawer .cart-item__error {
        max-width: 100% !important;
      }
    }

    @media screen and (max-width: 380px) {
      .cart-drawer .cart-item:not(.bhakti-cart-auto-gift) {
        grid-template-columns: 8rem minmax(0, 1fr) !important;
        column-gap: .9rem !important;
        padding: .9rem !important;
      }

      .cart-drawer .cart-item:not(.bhakti-cart-auto-gift) > .cart-item__media,
      .cart-drawer .cart-item:not(.bhakti-cart-auto-gift) .cart-item__image-container,
      .cart-drawer .cart-item:not(.bhakti-cart-auto-gift) .cart-item__image {
        width: 8rem !important;
        min-width: 8rem !important;
        max-width: 8rem !important;
      }

      .cart-drawer .cart-item:not(.bhakti-cart-auto-gift) .cart-item__image {
        height: 8rem !important;
      }

      .cart-drawer .quantity-popover-container,
      .cart-drawer .quantity {
        flex-basis: 10.8rem !important;
        width: 10.8rem !important;
        min-width: 10.8rem !important;
        max-width: 10.8rem !important;
      }

      .cart-drawer .quantity {
        grid-template-columns: repeat(3, 3.6rem) !important;
      }

      .cart-drawer .quantity__button,
      .cart-drawer .quantity__input {
        width: 3.6rem !important;
        max-width: 3.6rem !important;
        height: 3.6rem !important;
        min-height: 3.6rem !important;
        max-height: 3.6rem !important;
      }

      .cart-drawer cart-remove-button,
      .cart-drawer .cart-remove-button {
        flex-basis: 3.6rem !important;
        width: 3.6rem !important;
        min-width: 3.6rem !important;
        max-width: 3.6rem !important;
        height: 3.6rem !important;
        min-height: 3.6rem !important;
        max-height: 3.6rem !important;
      }

      .cart-drawer .bhakti-cart-auto-gift {
        grid-template-columns: 5.8rem minmax(0, 1fr) !important;
        column-gap: .75rem !important;
        padding: .8rem .9rem !important;
      }

      .cart-drawer .bhakti-cart-auto-gift > .cart-item__media,
      .cart-drawer .bhakti-cart-auto-gift .cart-item__image-container,
      .cart-drawer .bhakti-cart-auto-gift .cart-item__image {
        width: 5.8rem !important;
        min-width: 5.8rem !important;
        max-width: 5.8rem !important;
      }

      .cart-drawer .bhakti-cart-auto-gift .cart-item__image {
        height: 5.8rem !important;
      }
    }
  `;
  document.head.appendChild(style);

  let frame = 0;

  const polishDrawer = () => {
    frame = 0;
    const drawer = document.getElementById('CartDrawer');
    if (!drawer) return;

    const paidRows = Array.from(drawer.querySelectorAll('.cart-item:not(.bhakti-cart-auto-gift)'));
    const paidCount = paidRows.reduce((sum, row) => {
      const input = row.querySelector('.quantity__input');
      return sum + Math.max(0, Number(input?.value || 1));
    }, 0);

    const count = drawer.querySelector('.bhakti-cart-count');
    if (count) {
      count.textContent = `(${paidCount} ${paidCount === 1 ? 'item' : 'items'})`;
    }

    const giftRows = Array.from(drawer.querySelectorAll('.bhakti-cart-auto-gift'));
    const giftCount = giftRows.reduce((sum, row) => {
      const input = row.querySelector('.quantity__input');
      return sum + Math.max(0, Number(input?.value || 0));
    }, 0);

    if (giftCount > 0) {
      const offer = drawer.querySelector('.bhakti-cart-offer span');
      if (offer) offer.innerHTML = `<strong>${giftCount} FREE bracelet${giftCount === 1 ? '' : 's'} included</strong>`;
      giftRows.forEach((row) => {
        const badge = row.querySelector('.bhakti-cart-gift-badge');
        if (badge) badge.textContent = 'FREE GIFT';
      });
    }
  };

  const schedulePolish = () => {
    if (frame) return;
    frame = window.requestAnimationFrame(polishDrawer);
  };

  const attachObserver = () => {
    const drawer = document.getElementById('CartDrawer');
    if (!drawer) return false;
    if (drawer.dataset.bhaktiProfessionalObservedV4 === 'true') return true;
    drawer.dataset.bhaktiProfessionalObservedV4 = 'true';
    new MutationObserver(schedulePolish).observe(drawer, { childList: true, subtree: true });
    schedulePolish();
    return true;
  };

  document.addEventListener('click', (event) => {
    const minusButton = event.target?.closest?.('.cart-drawer .quantity__button[name="minus"]');
    if (!minusButton || minusButton.disabled) return;

    const row = minusButton.closest('.cart-item');
    if (!row || row.classList.contains('bhakti-cart-auto-gift')) return;

    const input = row.querySelector('.quantity__input');
    const quantity = Number(input?.value || 0);
    if (!input || quantity > 1) return;

    const cartItems = minusButton.closest('cart-drawer-items');
    if (!cartItems || typeof cartItems.updateQuantity !== 'function') return;

    event.preventDefault();
    event.stopImmediatePropagation();
    cartItems.updateQuantity(
      input.dataset.index,
      0,
      event,
      'minus',
      input.dataset.quantityVariantId
    );
  }, true);

  const boot = () => {
    if (attachObserver()) return;
    const bodyObserver = new MutationObserver(() => {
      if (attachObserver()) bodyObserver.disconnect();
    });
    bodyObserver.observe(document.body, { childList: true, subtree: true });
  };

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', boot, { once: true });
  } else {
    boot();
  }

  document.addEventListener('shopify:section:load', () => {
    attachObserver();
    schedulePolish();
  });
})();
